import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackRoute } from '../utils/analytics';

/**
 * Applies the Google Analytics policy in src/utils/analytics.ts on every route
 * change: measure the public pre-login pages, disable measurement everywhere
 * else. Renders nothing.
 */
export default function AnalyticsTracker() {
  const { pathname } = useLocation();
  useEffect(() => { trackRoute(pathname); }, [pathname]);
  return null;
}
